export default "__VITE_ASSET__CU3FapXI__"